import { useIntlModule, IntlModuleTypes } from '@enterprise/common';
import messages from './docsSidePanel.intl.json';

export type DocsSidePanelIntlKey = IntlModuleTypes.IntlKeys<typeof messages>;
export type DocsSidePanelIntlMessages = ReturnType<typeof useDocsSidePanelIntl>;

export function useDocsSidePanelIntl() {
  return useIntlModule(messages);
}
